import "./login.css";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { UsuarioAutenticadoContext } from "../../context/authenticatedUser";
import CircularProgress from '@material-ui/core/CircularProgress';
import ojoAbierto from "../../commons/images/open-eye.svg";
import ojoCerrado from "../../commons/images/close-eye.svg";
import { Button } from 'react-bootstrap';
import taxoApi from '../../api/taxoApi';
import { Context } from "../../commons/utils/store";
import { setWithExpiry } from '../../commons/utils/jwt';

function Login() {
  const [mostrarMensajeTokenCaducado, setMostrarMensajeTokenCaducado] = useState(false);
  const [state, dispatch] = useContext(Context);
  const { usuarioAutenticadoChange, logout } = useContext(UsuarioAutenticadoContext);
  const [usuario, setUsuario] = useState();
  const [password, setPassword] = useState();
  const [mostrandoPassword, setMostrandoPassword] = useState(false);
  const [mensajeError, setMensajeError] = useState(null);
  const [cargando, setCargando] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    if (!mostrarMensajeTokenCaducado && localStorage.getItem("sesion") === "caducada") {
      logout();
      setMostrarMensajeTokenCaducado(true);
    }
  }, [])
  
  useEffect(() => {
    dispatch({ type: "SET_HIDDEN", payload: true });
  }, [state === false]);

  const ejecutarInicioDeSesion = async (e) => {
    setMensajeError(null);

    setCargando(true)
    e.preventDefault();
    try {
      try {
        let response = await taxoApi.authLogin({ user: usuario, password: password });
        let result = await response;
        if (response.authorizationToken !== undefined && response.authorizationToken !== null) {
          setWithExpiry("token-taxo",result.authorizationToken)
          localStorage.setItem("sesion","activa");
          usuarioAutenticadoChange({ 
            user: usuario, 
            password: password,
            id_usuario: result.id, 
            id_entidad: result.id_entidad, 
            desc_entidad: result.desc_entidad, 
            alias: result.alias, 
            permiso_ver_dashboard: result.PERMISO_VER_DASHBOARD
          });
          history("/");
        }
        else {
          localStorage.removeItem('token-taxo')
          setMensajeError(response.error);
        }

      }
      catch (error) {
        setMensajeError(error);
      }
    } catch (error) {
      console.log(error)
      setMensajeError(error);
    }
    setCargando(false)
  };

  return (
    <div className="flex-box">
      <div className="login-box px-md-0">
        <div className="login-form">
          <form
            onSubmit={ejecutarInicioDeSesion} >
            <div className="sign-in-header">
              <div style={{ marginTop: '1rem' }}>
                <h1 style={{ color: 'lightgrey', }}>Iniciar sesión</h1>
              </div>
            </div>
            <div className="sign-in-fields">
              <input
                className="form-control special-form-control gris-principal"
                type="text"
                placeholder="Usuario"
                onChange={(e) => setUsuario(e.target.value)}
              />
              <div className="passwd-box">
                <img
                  src={mostrandoPassword ? ojoCerrado : ojoAbierto}
                  className='toggle_pwd'
                  alt="Mostrar/No mostrar contraseña"
                  onClick={(e) => setMostrandoPassword((previous, props) => !previous)}
                />
                <input
                  className="form-control special-form-control gris-principal"
                  type={mostrandoPassword ? "text" : "password"}
                  placeholder="Contraseña"
                  onChange={(e) => setPassword(e.target.value)}
                /></div>
            </div>
            {!cargando && (
              <Button
                className='btn btn-primary mid-button' type="submit"

                disabled={!usuario || !password} >Iniciar sesión</Button>
            )}
            {cargando && (
              <CircularProgress />
            )}

            {mensajeError && <Alert severity="error">{mensajeError}</Alert>}
            {mostrarMensajeTokenCaducado && <Alert className='mt-2' severity="warning">Se ha caducado su sesión por seguridad. Por favor, vuelva a iniciar sesión. </Alert>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
